<template>
    <div v-if="paciente && paciente.paciente_unidade">
        <span v-if="paciente && paciente.sinalizadores" class="mr-3">
            <span v-for="(sinal, isx) in paciente.sinalizadores" :key="isx" :title="sinal.sinalizador.search">
                <i class="fa-fw" :class="( sinal.sinalizador.st_icon ? sinal.sinalizador.st_icon : 'fas fa-flag') + ' text-'  + sinal.sinalizador.st_cor" aria-hidden="true"></i>
            </span>
        </span>
        <small>
            <span class="badge mr-1" :class="paciente.paciente_unidade.fl_vip == '1' ? 'badge-primary' : 'badge-light text-muted'"
                v-if="paciente.paciente_unidade.fl_vip == '1'"
                data-toggle="tooltip" data-placement="top" title="VIP">
                <i class="fas fa-star"></i>
            </span>
            <span class="badge mr-1" :class="paciente.paciente_unidade.fl_faltoso == '1' ? 'badge-primary' : 'badge-light text-muted'"
                v-if="paciente.paciente_unidade.fl_faltoso == '1'"
                data-toggle="tooltip" data-placement="top" title="Faltoso">
                <i class="fas fa-times"></i>
            </span>
            <span class="badge mr-1" :class="paciente.paciente_unidade.fl_devedor == '1' ? 'badge-primary' : 'badge-light text-muted'"
                v-if="paciente.paciente_unidade.fl_devedor == '1'"
                data-toggle="tooltip" data-placement="top" title="Devedor">
                <i class="fas fa-dollar-sign"></i>
            </span>
            <span class="badge mr-1" :class="paciente.paciente_unidade.fl_bloqueado == '1' ? 'badge-primary' : 'badge-light text-muted'"
                v-if="paciente.paciente_unidade.fl_bloqueado == '1'"
                data-toggle="tooltip" data-placement="top" title="Bloqueado">
                <i class="fas fa-lock"></i>
            </span>
        </small>
    </div>
</template>

<script>
export default {
    props: ['paciente']
}
</script>